export const environment = {
  local: false,
  production: true,
  // Real customer traffic: kept low so tracing/profiling/replay volume (and Sentry
  // quota cost) scales with actual usage rather than every session. Errors always
  // carry their replay (replaysOnErrorSampleRate: 1) regardless of session sampling.
  sentry: {
    enabled: false,
    tracesSampleRate: 0.2,
    profilesSampleRate: 0.25,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  },
  parseAPPID: 'cZdZP9LFErufKhdHzkSvUkFHmjpJ5hZ2LiphqXY8',
  parseJSKey: 's4mgz2k48hSZNWDHkULPF5pbc5ZnyZYDSAaj26uF',
  parseServerURL: 'https://parse.prosafecon.de/parse',
  parseUserClass: {
    user: 'User',
    _user: '_User',
  },
  parseRoleClass: '_Role',
  features: {
    certificate: true,
    notes: true,
    contract: true,
    annualReport: true,
    statistics: true,
    map: true,
    protocol: true,
    legacyProtocol: false,
    library: true,
    paymentPeriod: false,
    accountingRange: true,
    templateChangeHistory: true,
    contractChangeHistory: true,
    v2Reporting: false,
    defaultReport: 'V2'
  }
};
